export default "__VITE_ASSET__11b66164__"